const LEVELS = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
};

function getLevel() {
  const raw = (process.env.REACT_APP_LOG_LEVEL || "info").toLowerCase();
  return Object.prototype.hasOwnProperty.call(LEVELS, raw) ? LEVELS[raw] : 2;
}

function mask(value) {
  if (!value) return value;
  const s = String(value);
  if (s.length <= 8) return "***";
  return `${s.slice(0, 4)}***${s.slice(-2)}`;
}

function sanitize(meta) {
  if (!meta || typeof meta !== "object") return meta;
  const safe = Array.isArray(meta) ? [...meta] : { ...meta };
  if (safe.apiKey) safe.apiKey = mask(safe.apiKey);
  return safe;
}

function emit(level, scope, message, meta) {
  const currentLevel = getLevel();
  if (LEVELS[level] > currentLevel) return;

  const prefix = `[item-checker:${scope}]`;
  const payload = meta === undefined ? undefined : sanitize(meta);

  // Keep it readable in DevTools; don’t force JSON only.
  // eslint-disable-next-line no-console
  const fn =
    level === "error"
      ? console.error
      : level === "warn"
      ? console.warn
      : level === "debug"
      ? console.debug
      : console.log;

  if (payload === undefined) fn(prefix, message);
  else fn(prefix, message, payload);
}

export function createLogger(scope) {
  return {
    error: (message, meta) => emit("error", scope, message, meta),
    warn: (message, meta) => emit("warn", scope, message, meta),
    info: (message, meta) => emit("info", scope, message, meta),
    debug: (message, meta) => emit("debug", scope, message, meta),
  };
}
